import * as React from 'react';

import { track } from '@klokhuis/core/Analytics/libs/analytics-lib';
import { AnalyticsEvent } from '@klokhuis/core/Analytics/types';
import { PageLayout } from '@klokhuis/core/PageLayout';
import { useFilterSelectors } from '@klokhuis/modules/Properties/context/hooks/useFilterSelectors';
import { ListingsContext } from '@klokhuis/modules/Properties/context/ListingsContext';
import { SearchView } from '@klokhuis/modules/Properties/types';

import GridView from '../GridView';

import styles from './Searchview.module.css';
import { TopPartners } from '../TopPartners/TopPartners';
import { NewlyListed } from '../NewlyListed/NewlyListed';
import AgentPartnership from '../AgentPartnership/AgentPartnership';
import PropertyTypeFilter from '../PropertyTypeFilter';

const SearchViews = () => {
  const { listingsState } = ListingsContext.useContext();

  const { isValidCity } = useFilterSelectors();

  const isListView =
    listingsState.filterResult.filters.searchview === SearchView.List;

  React.useEffect(() => {
    if (isValidCity() && isListView) {
      const cityName = listingsState.filterResult.filters.location?.cityName;
      const trackPayload = {
        query: cityName,
        search_string: cityName,
      };
      track(AnalyticsEvent.SearchWithCity, trackPayload);
    }
  }, [listingsState, isListView, isValidCity]);
  return (
    <PageLayout.MainRaw className={styles.root}>
      <div className={styles.filterContainer}>
        <PropertyTypeFilter />
      </div>

      <GridView />
      <TopPartners />
      {/* <NewlyListed /> */}
      <AgentPartnership />
    </PageLayout.MainRaw>
  );
};

export default SearchViews;
